<template>
  <div style="width: 100%;overflow: auto;height: calc(100vh - 64px - 48px)">
    <div class="index_box fix">
      <div class="box_item l">
        <div class="item_title">
          工作看板
        </div>
        <div class="item_box ">
          <div class="item_top fix">
            <div class="item_img l">
              <img src="@/assets/img/daiban.png" alt="">
            </div>
            <div class="agency_sth l">
              待办事项
              <span v-if="homePageData.todayTaskSum" class="agency_num">
                   {{ 1 + momentList.length + msgList.length }}
              </span>
              <span v-else class="agency_num">
                {{ momentList.length + msgList.length }}
              </span>
            </div>
            <!--            <div class="no_complete r fix" >-->
            <!--              <div v-if="homePageData.todayTaskSum - homePageData.hadFinishSum" class="l">未完成</div>-->
            <!--              <div v-else class="l">已完成</div>-->
            <!--              <div class="down_img r">-->
            <!--                <img src="@/assets/img/down.png" alt="">-->
            <!--              </div>-->

            <!--            </div>-->
          </div>
          <div class="agency_box">
            <div class="agency_item">
              <div class="regular_follow">
                定期跟进项目
              </div>
              <div class="agency_rate">
                <div class="contacts_num" @click="goClueToday" style="cursor: pointer">
                  你今日还有{{ homePageData.todayTaskSum - homePageData.hadFinishSum }}个线索需跟进
                </div>
                <div class="today_rate">今日完成进度（{{ homePageData.hadFinishSum }}/{{ homePageData.todayTaskSum }})</div>
                <div class="progress_bar">
                  <div v-if="homePageData.todayTaskSum - homePageData.hadFinishSum" class="progress"
                       :style="{width:'calc('+homePageData.hadFinishSum/homePageData.todayTaskSum*100+'%)'}">
                  </div>
                  <div v-else-if="homePageData.todayTaskSum === homePageData.hadFinishSum" class="progress"
                       :style="' width:100%'">
                  </div>
                  <div v-else class="progress" :style="'width:0'">33</div>
                </div>
              </div>
            </div>
            <div class="agency_item">
              <div class="regular_follow">
                日常任务
              </div>
              <template v-if="momentList.length || msgList.length">
                <div class="agency_rate" v-for="(item,index) in momentList" :key="'moment'+index">
                  <div class="agency_title fix">
                    <div class="be_overdue l">待办</div>
                    <div class="be_overdue_name l">{{ item.taskTitle }}</div>
                    <div class="be_overdue_time r">{{ item.createDate }}</div>
                  </div>
                  <div class="contacts_num">{{ item.content }}</div>
                  <div class="today_rate">任务类型：朋友圈任务</div>
                  <div class="today_rate">责任人：{{ item.userName }}</div>
                </div>

                <div class="agency_rate" v-for="(item,index) in msgList" :key="'mission'+index">
                  <div class="agency_title fix">
                    <div class="be_overdue l">待办</div>
                    <div class="be_overdue_name l">{{ item.taskTitle }}</div>
                    <div class="be_overdue_time r">{{ item.createDate }}</div>
                  </div>
                  <div class="contacts_num">{{ item.taskContent }}</div>
                  <div class="today_rate">任务类型：群发任务</div>
                  <div class="today_rate">责任人：{{ item.userName }}</div>
                </div>
              </template>
              <div v-if="!momentList.length && !msgList.length" style="margin-top: 20px">
                暂无任务
              </div>
            </div>
          </div>

        </div>

      </div>
      <div class="box_item l">
        <div class="no_contact_box" style="height: auto;position: relative">
          <div class="item_top fix">
            <div class="item_img l">
              <img src="@/assets/img/loudoutu.png" alt="">
            </div>
            <div class="agency_sth l">
              销售漏斗
              <a-button @click="visible = true">筛选</a-button>
            </div>
          </div>
          <div id="myChart" style="width: 100%;height: 350px;overflow-y: hidden"></div>
          <ul class="percent">
            <li style="color: #000">意向客户占比{{ percent.percentHadClubCust }}%</li>
            <li>线索跟进率{{ percent.percentHadReportClue }}%</li>
            <li>成交转化率{{ percent.percentSuccessClue }}%</li>
            <li>保客再购率{{ percent.percentCustBuy }}%</li>
          </ul>
          <a-drawer
              :title="null"
              placement="top"
              :height="300"
              :closable="false"
              :visible="visible"
              :get-container="false"
              :wrap-style="{ position: 'absolute' }"
              @close="onClose"
          >
            <div class="search">
              <div class="item">
                <span class="label">时间：</span>
                <a-range-picker v-model="dataRangeAgain" :valueFormat="'YYYY-MM-DD'"
                                style="width: 75%"></a-range-picker>
              </div>
              <div class="item" v-if="!onlyOne">
                <span class="label">经理部：</span>
                <a-select v-model="deptId" :options="deptList" @change="handleChangeDept"></a-select>
              </div>
              <div class="item">
                <span class="label">经销商：</span>
                <a-button v-if="onlyOne" disabled>{{ theOne }}</a-button>

                <a-button v-if="!onlyOne" @click="dealderModalShow=true">
                  <span v-if="!dealerId">请选择经销商</span>
                  <span v-if="dealerId">{{ showDealerName }}</span>
                </a-button>

                <!--                <a-select v-model="dealerId" :options="dealerList"></a-select>-->
                <!--                                弹出层-->
                <a-modal forceRender
                         v-model="dealderModalShow"
                         title="经销商"
                         :width="500"
                         ok-text="确认"
                         cancel-text="取消"
                         @ok="chooseDealer"
                         @cancel="dealderModalShow=false; dealerKws='';isChosen=false;"
                >
                  <a-input-search
                      v-model="dealerKws"
                      placeholder="请输入关键字"
                      size="large"
                      style="margin-bottom: 10px;"
                  />


                  <div style="margin-bottom:5px; float:right; font-size:15px; font-weight:700; color:rgb(2,84,96)">
                    {{ dealerNumber }}条数据
                  </div>
                  <!--                <div style="margin-bottom:5px; float:right; font-size:15px; font-weight:700; color:rgb(234, 34, 33)">-->
                  <!--                  {{ dealerCityName }}-->
                  <!--                </div>-->
                  <div style="margin-bottom:5px; float:left; font-size:15px; font-weight:700; color:rgb(2,84,96)">
                    {{ dealerDeptName }}
                  </div>


                  <a-radio-group style=" width:452px; height:355px; overflow-y: scroll;overflow-x: hidden;"
                                 name="radioName"
                                 v-model="dealerIdModal"
                                 @change="changeRadio">
                    <template v-for="(item,index) in dealerSearchModalList">
                      <div :key="index" style="height: 40px; padding-left: 20px;padding-right: 20px"
                           :class="{'radio-chose':dealerIdModal === item.dealerIdModal}"
                           @click.prevent="chooseOrNot(item.dealerIdModal)">
                        <a-radio style="height: 40px;padding-top:6px"
                                 :value=item.dealerIdModal
                        > {{ item.dealerNameModal }}
                          <img src="@/assets/img/right.png" style="width: 20px; float: right;display: none" alt="">
                        </a-radio>

                      </div>
                    </template>

                  </a-radio-group>
                </a-modal>
              </div>
              <div class="item">
                <span class="label">城市：</span>
<!--                <a-select v-model="cityId" :options="cityList" @change="handleChangeCity"></a-select>-->
                <a-cascader
                    :options="cityList"
                    expand-trigger="hover"
                    v-model="cityId"
                    @change="handleChangeCity"
                    :fieldNames="{
                      label: 'areaName',
                      value: 'areaCode',
                      children: 'children',
                    }"
                    placeholder="请选择城市"
                />
              </div>

              <div class="item">
                <span class="label">品系：</span>
                <a-select v-model="strainId" :options="strainList"></a-select>
              </div>

              <div class="item">
                <span class="label">客户类型：</span>
                <a-select v-model="custCategoryId" :options="custList"></a-select>
              </div>

              <div class="opt">
                <a-button type="primary" @click="listData">筛选</a-button>
                <a-button @click="reset">重置</a-button>
              </div>
            </div>
          </a-drawer>
        </div>
        <div class="no_contact_box" style="margin-top: 15px;height: 486px">
          <div class="item_top_one fix">
            <div class="item_top_small item_top_small_again l" @click="changeList(1)" :class="{active:current===1}">
              <div class="item_img">
                <img src="@/assets/img/weilianxikehu.png" alt="">
              </div>
              <div style="display: flex;justify-content: space-between;width: 85%;">
                <div class="agency_sth">
                  未跟进客户
                  <span class="agency_num">{{ noContactDataSize }}</span>
                </div>
                <span style="align-self: center" @click="toCustList(-1)">更多 >></span>
              </div>
            </div>

            <div class="item_top_small l fix" @click="changeList(2)" :class="{active:current===2}">
              <div class="item_img">
                <img src="@/assets/img/genjinzhongkehu.png" alt="">
              </div>
              <div style="display: flex;justify-content: space-between;width: 85%;">
                <div class="agency_sth">
                  跟进中客户
                  <span class="agency_num">{{ contactCustDataSize }}</span>
                </div>
                <span style="align-self: center" @click="toCustList(1)">更多 >></span>
              </div>

            </div>
          </div>
          <div class="no_contact" v-if="current===1">

            <template v-if="noContactData.length">
              <div class="contact_item fix" v-for="item in noContactData" :key="item.custId">
                <div class="contact_head l">
                  <img :src="item.avatar|fileWxPath" alt="" v-if="item.avatar">
                  <a-avatar shape="square" :size="55" icon="user" v-else/>
                </div>

                <div class="customer_details l">
                  <div class="contact_name">{{ item.custName }}<span>@微信</span></div>
                  <div class="customer_com">
                    客户企业：{{ item.companyName ? item.companyName : '暂无企业信息' }}
                  </div>
                </div>

              </div>
            </template>
            <div v-else style="margin-top: 20px">
              您暂时没有未跟进的客户
            </div>

          </div>
          <div class="no_contact" v-else>
            <template v-if="contactCustData.length">
              <div class="contact_item fix" v-for="(item,index) in contactCustData" :key="index">
                <div class="contact_head l">
                  <img :src="item.avatar|fileWxPath" alt="" v-if="item.avatar">
                  <a-avatar shape="square" :size="55" icon="user" v-else/>
                </div>
                <div class="customer_details l">
                  <div class="contact_name">{{ item.custName }}<span>@微信</span></div>
                  <div class="customer_com">
                    客户企业：{{ item.companyName ? item.companyName : '暂无企业信息' }}
                  </div>

                </div>

              </div>
            </template>
            <div v-else style="margin-top: 20px">
              您暂时没有跟进中的客户
            </div>


          </div>
        </div>
      </div>
      <div class="box_item l">
        <div class="item_title">
          数据简报
        </div>
        <div class="item_box">
          <div class="item_data fix ">
            <div class="screen_time fix">
              <div class="l" style="width:50%">
                <a-range-picker v-model="dateRange" :valueFormat="'YYYY-MM-DD'"></a-range-picker>
              </div>

              <a-button class="date_screen l" @click="searchDateRange">筛选</a-button>
              <a-button class="date_screen l" @click="reset1">重置</a-button>
              <div class="search_tips l">

                <div id="components-popover-demo-placement">
                  <a-popover placement="bottomRight">
                    <template slot="content">
                      <p>1.筛选项为新增客户数、新增线索数、新增订车数</p>
                      <p>2.累计客户数累计订车数为累计数量</p>
                      <p>3.未跟进线索数、公海池线索数、待分配线索数、<br>已分配线索数为实时数量</p>
                    </template>
                    <div class="tips_img">
                      <img src="@/assets/img/fill.png" alt="">
                    </div>
                  </a-popover>

                </div>
              </div>
            </div>
            <div class="tips_details ">
              <!--              <img src="@/assets/img/tips.png" alt="">-->


            </div>

            <div class="customer_type">
              <div class="customer_num fix">
                <div class="customer_img l">
                  <img src="@/assets/img/kehushu.png" alt="">
                </div>
                <div class="agency_sth l">
                  客户数
                </div>
              </div>
              <div class="customer_data fix">
                <div class="customer_item l">
                  <div class="item_num" @click="customerList">{{ briefingData.newAddCustCount }}</div>
                  <div class="item_text">新增客户数</div>

                </div>
                <div class="customer_item l">
                  <div class="item_num" @click="customerListAgain">{{ briefingData.sumCustCount }}</div>
                  <div class="item_text">累计客户数</div>
                </div>

              </div>
            </div>
            <div class="customer_type">
              <div class="customer_num fix">
                <div class="customer_img l">
                  <img src="@/assets/img/xiansuoshu.png" alt="">
                </div>
                <div class="agency_sth l">
                  线索数
                </div>
              </div>
              <div class="customer_data fix">
                <div class="customer_item l" @click="cluesList">
                  <div class="item_num">{{ briefingData.newAddClueCount }}</div>
                  <div class="item_text">新增线索数</div>
                </div>
                <div class="customer_item l" @click="cluesListAgain">
                  <div class="item_num">{{ briefingData.notFollowRecordCount }}</div>
                  <div class="item_text">未跟进线索数</div>
                </div>
                <div class="customer_item l" @click="cluePool(0)">
                  <div class="item_num">{{ briefingData.cluePoolByAreaCount }}</div>
                  <div class="item_text">公海池线索数</div>
                </div>
                <div class="customer_item l" @click="clueHis">
                  <div class="item_num">{{ briefingData.alreadyAllocationCluePoolCount }}</div>
                  <div class="item_text">已分配线索数</div>
                </div>
                <div class="customer_item l" @click="cluePool(1)">
                  <div class="item_num">{{ briefingData.waitAllocationCluePoolCount }}</div>
                  <div class="item_text">待分配线索数</div>
                </div>


              </div>
            </div>
            <div class="customer_type">
              <div class="customer_num fix">
                <div class="customer_img l">
                  <img src="@/assets/img/dingcheshu.png" alt="">
                </div>
                <div class="agency_sth l">
                  订车数
                </div>
              </div>
              <div class="customer_data fix">
                <div class="customer_item l" style="cursor: pointer" @click="toClueList(briefingData.newClues)">
                  <div class="item_num">{{ briefingData.newAddOrderCount }}</div>
                  <div class="item_text">新增订车数</div>

                </div>
                <div class="customer_item l" style="cursor: pointer" @click="toClueList(briefingData.allClues)">
                  <div class="item_num">{{ briefingData.sumOrderCount }}</div>
                  <div class="item_text">累计订车数</div>
                </div>

              </div>
            </div>


          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import {dataApi} from "@/services/indexPage";
import api from "@/services/api";
import XEUtils from "xe-utils";
import {mapMutations, mapState} from "vuex";

import {dealTreeNoChild,loadBaseCodeData,loadCityTreeCasData} from "@/services/baseCodeSource";
// import $ from 'jquery'
// eslint-disable-next-line no-unused-vars
// const bodystyle = {
//       height: '480px',
//
//     }
export default {

  data() {
    return {
      //书签
      onlyOne: false,
      theOne: '',
      dealerCityName: '',
      dealerDeptName: '',
      checked: false,
      dealderModalShow: false,
      dealerKws: '',
      isChosen: false,
      dealerIdModal: 0,
      dealerNameModal: '',
      showDealerName: '',
      resData: [],
      userNo: '',
      current: 1,
      show: true,
      api: api,
      buttonWidth: 70,
      homePageData: {
        hadFinishSum: 0,
        todayTaskSum: 0
      },//首页数据
      contactCustData: [],//跟进中客户
      contactCustDataSize: 0,
      noContactData: [],//待跟进客户
      noContactDataSize: 0,
      momentList: [],//朋友圈任务
      msgList: [],//群发任务
      briefingData: {},//数据简报
      dateRange: [XEUtils.toDateString(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd'), XEUtils.toDateString(new Date(), 'yyyy-MM-dd')],
      dataRangeAgain: [XEUtils.toDateString(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd'), XEUtils.toDateString(new Date(), 'yyyy-MM-dd')],
      visible: false,
      strainId: 0,
      strainList: [],
      deptId: 0,
      deptList: [],
      cityId: 0,
      cityList: [],
      dealerId: 0,
      dealerList: [],
      dealerModalList: [],
      dealerSearchModalList: [],
      dealerType: '',
      percent: {},
      custCategoryId: 0,//筛选 客户类型
      custList: [],
    };
  },
  computed: {
    ...mapState("account", {currUser: "user"}),
  },
  watch: {

    //书签
    dealerKws: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        // const vm = this
        console.log(`原关键词: ${newVal}`);
        console.log(`现关键词: ${oldVal}`);
        // console.log(`dealerModalList: `, this.dealerModalList);

        this.dealerSearchModalList = this.dealerModalList.filter(item => item.dealerNameModal.includes(this.dealerKws))
        // for(key in this.dealerModalList){
        //   if([this.dealerName].includes(this.dealerKws)){
        //     console.log('=======================================')
        //   }
        // }
        this.dealerNumber = this.dealerSearchModalList.length

        // console.log(`this.dealerNumber: `, this.dealerNumber);
      }
    },
    dealerIdModal(n, o) {
      console.log(n)
      console.log(o)
    }
  },
  //过滤 头像照片格式
  filters: {
    fileWxPath(data) {
      if (data && data.includes('http')) {
        return data;
      } else {
        return api.temp.FILE_PATH + data
      }
    }
  },
  mounted() {
    // console.log($("input[type='radio']:checked").val())
    this.searchDateRange()
    this.initSearch()
    // 待办事项及跟进客户接口
    this.getData()
    this.userNo = this.currUser.userNo
    console.log(this.currUser)
  },
  methods: {
    chooseOrNot(val) {
      // this.dealerIdModal === val ? this.dealerIdModal = 0 : this.dealerIdModal = val
      if (this.dealerIdModal === val) {
        this.dealerIdModal = 0
        // this.showDealerName = '请选择经销商'
        this.dealerId = 0

      } else {
        this.dealerIdModal = val
      }
    },
    chooseDealer() {
      if (this.dealerIdModal) {
        this.dealerId = this.dealerIdModal
        // this.showDealerName=this.dealerNameModal
        // console.log(`dealerModalList: `, this.dealerModalList);
        // console.log(`dealerId: `, this.dealerId);
        let list = this.dealerModalList.filter(item => item.dealerIdModal === this.dealerId)
        // console.log(list)
        this.showDealerName = list[0].dealerNameModal
        this.dealderModalShow = false
      } else {
        this.dealderModalShow = false
      }
    },
    changeRadio() {
      this.isChosen = true
    },
    onSearch() {

    },
    ...mapMutations('setting', ['setStartTime', 'setEndTime', 'setSwitch', 'setIsTodayFollow']),
    toClueList(Array) {
      // console.log(Array)
      let string = 'noData';
      if (Array.length) {
        string = Array.join(',');
      }
      this.$router.push({
        path: "/clue/clueManage",
        query: {fromIndexParam: string},
      });
    },
    drawLine(res) {
      this.percent = res
      // 基于准备好的dom，初始化echarts实例
      var chartDom = document.getElementById('myChart');
      var myChart = this.$echarts.init(chartDom);
      myChart.resize();
      var option
      option = {
        series: [
          {
            type: 'funnel',
            width: '80%',
            height: '70%',
            left: '5%',
            top: '5%',
            minSize: '1%',
            label: {
              show: true,
              position: 'inside'
            },
            sort: 'none',
            silent: true,
            data: [
              {value: 80, name: `新增客户数: ${res.addCustNum}`},
              {value: 50, name: `线索数: ${res.clubNum}`},
              {value: 20, name: `成交数: ${res.successClubNum}`}
            ],
            color: ['#488fea', '#47c6eb', '#5aedc2']
          },
          {
            type: 'funnel',
            width: '80%',
            height: '20%',
            left: '5%',
            top: '75%',
            sort: 'ascending',
            silent: true,
            label: {
              show: true,
              position: 'inside'
            },
            data: [
              {value: 80, name: `保有客户数: ${res.liuCustNum}`}
            ],
            color: ['#68eab1']
          }
        ]
      };
      option && myChart.setOption(option)
    },
    async getData() {
      await dataApi.indexData().then(res => {
        this.homePageData = res.data
        this.contactCustData = res.data.contactCustData;
        this.noContactDataSize = res.data.noContactDataSize;
        this.contactCustDataSize = res.data.contactCustDataSize;
        this.noContactData = res.data.noContactData
        this.momentList = res.data.momentList
        this.msgList = res.data.msgList
        // let num = this.homePageData.todayTaskSum - this.homePageData.hadFinishSum
      })
    },
    //筛选
    searchDateRange() {
      if (!this.dateRange[0] || !this.dateRange[1]) {
        this.$message.error('请选择筛选日期')
      } else {
        this.getBriefingData(this.dateRange[0] + ' 00:00:00', this.dateRange[1] + ' 23:59:59')
      }
    },

    toCustList(type) {
      this.$router.push({
        path: '/client/customer',
        query: {
          isFollowCust: type
        }
      })
    },

    changeList(index) {
      this.current = index;
    },

    // searchDateRangeAgain() {
    //   this.listData(this.currUser.userNo, this.dataRangeAgain[0] + ' 00:00:00', this.dataRangeAgain[1] + ' 23:59:59')
    // },

    async listData() {
      if (!this.dataRangeAgain[0] || !this.dataRangeAgain[1]) {
        this.$message.error('请选择日期')
        return false
      }
      const params = {
        userNo: this.currUser.userNo,
        startDate: this.dataRangeAgain[0] + ' 00:00:00',
        endDate: this.dataRangeAgain[1] + ' 23:59:59',
        deptId: this.deptId,
        cityId: this.cityId[1],
        dealerId: this.dealerId,
        strainId: this.strainId,
        custCategoryId: this.custCategoryId,
        type: 1
      }
      this.resData = await dataApi.listData(params);
      let res = this.resData;
      // this.message.loading(`加载中...`)
      if (res.code === 200) {
        this.drawLine(res.data)
      }
      this.visible = false
    },

    // 跳转
    customerList() {
      this.setStartTime(this.dateRange[0] + ' 00:00:00')
      this.setEndTime(this.dateRange[1] + ' 23:59:59')
      this.$router.push({path: '/client/customer'})
    },
    customerListAgain() {
      this.setStartTime(null)
      this.setEndTime(null)
      this.$router.push('/client/customer')
    },
    goClueToday() {
      this.setIsTodayFollow(1)
      this.$router.push({path: '/clue/clueManage'})
    },
    cluesList() {
      this.setStartTime(this.dateRange[0] + ' 00:00:00')
      this.setEndTime(this.dateRange[1] + ' 23:59:59')
      this.$router.push({path: '/clue/clueManage'})
    },
    cluesListAgain() {
      this.setStartTime(null)
      this.setEndTime(null)
      this.$router.push('/clue/clueManage?isNotFollow=' + 1)
    },
    cluePool(navSwitch) {
      this.setStartTime(this.dateRange[0] + ' 00:00:00')
      this.setEndTime(this.dateRange[1] + ' 23:59:59')
      this.setSwitch(navSwitch)
      this.$router.push({path: '/clue/saleCluePool'})
    },
    clueHis() {
      this.$router.push({path: '/clue/leadsAssigned'})
    },
    async getBriefingData(startDate, endDate) {
      // 数据简报接口
      let type = 1
      let resData = await dataApi.indexBriefingData(startDate, endDate, type, this.currUser.userNo);
      if (resData.code === 200) {
        this.briefingData = resData.data
      }
    },
    async initSearch() {
      let data = await dataApi.getStrainList();
      this.strainList = data.data.map(item => {
        return {
          value: item.strainId,
          label: item.strainName
        }
      })
      this.strainList.unshift({value: 0, label: '请选择品系'})

      // 客户类型
      let custTypeOption = await loadBaseCodeData('CD300003')//客户类型
      // console.log(custTypeOption);
      this.custList = custTypeOption.map(item => {
        return {
          value: item.codeId,
          label: item.codeName,
          orderNum: item.orderNum
        }
      })

      //按照客户要求排序
      this.custList.sort((a, b) => {
        return a.orderNum - b.orderNum
      })

      // console.log('排序746',this.custList);
      this.custList.unshift({value: 0, label: '请选择客户类型'})

      let data1 = await dataApi.getDeptList(this.currUser.userNo)
      this.deptList = data1.data.map(item => {
        return {
          value: item.deptId,
          label: item.deptName
        }
      })
      this.deptList.unshift({value: 0, label: '请选择经理部'})
      this.getCityList()
      this.getDealerList()
      this.listData()
    },
    async getCityList() {
      this.cityList = await loadCityTreeCasData();
      dealTreeNoChild(this.cityList);
      console.log(this.cityList)
      // this.cityList = data.data.map(item => {
      //   return {
      //     value: item.cityId,
      //     label: item.cityName
      //   }
      // })
      // this.cityList.unshift({value: 0, label: '请选择城市'})
    },
    // qf13
    async getDealerList() {
      let cityid = this.cityId[1] ? this.cityId[1] : 0
      let data = await dataApi.getDealerList(this.currUser.userNo, cityid, this.deptId)
      if (data.data.length === 1) {
        this.onlyOne = true
        this.theOne = data.data[0].deptName
        this.dealerId = data.data[0].deptId
        // console.log(1)
        this.listData()
      } else {
        this.onlyOne = false
        // console.log(data)
        // console.log(data.data.length)
        // console.log(2)
        this.dealerList = data.data.map(item => {
          return {
            value: item.deptId,
            label: item.deptName
          }
        })
        this.dealerList.unshift({value: 0, label: '请选择经销商'})

        this.dealerModalList = data.data.map(item => {
          return {
            dealerIdModal: item.deptId,
            dealerNameModal: item.deptName
          }
        })
        this.deptNameList = this.deptList.map(item => {
          return item.label
        })
        this.dealerSearchModalList = this.dealerModalList
        // console.log(`dealerSearchModalList: `, this.dealerSearchModalList);
        this.dealerNumber = this.dealerSearchModalList.length

      }
    },


    handleChangeDept() {
      let arr = this.deptList.filter(item => item.value === this.deptId)
      this.dealerDeptName = arr[0].label
      // this.getCityList()
      this.getDealerList()
      this.showDealerName = ''
      this.dealerId = 0
    },
    handleChangeCity() {
      console.log(this.cityId)
      let arr = this.cityList.filter(item => item.value === this.cityId[1])
      // console.log(arr)
      this.dealerCityName = arr[0].label
      // this.getDealerList()
    },
    reset() {
      this.deptId = 0
      this.dealerId = 0
      this.cityId = 0
      this.strainId = 0
      this.custCategoryId = 0
      this.dealerKws = ''
      this.dealerIdModal = 0
      this.dealerCityName = ''
      this.dealerDeptName = ''
      this.getDealerList()
      this.dataRangeAgain = [XEUtils.toDateString(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd'), XEUtils.toDateString(new Date(), 'yyyy-MM-dd')]
    },
    reset1() {
      this.dateRange = [XEUtils.toDateString(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd'), XEUtils.toDateString(new Date(), 'yyyy-MM-dd')]
      this.searchDateRange()
    },
    onClose() {
      this.visible = false
    }
  }
  ,
}
;
</script>

<style scoped lang="less">

/deep/ .ant-radio {
  display: none
}

/deep/ .ant-modal-content {
  height: 600px;

  .ant-input {
    background-color: rgb(248, 248, 248) !important;
    border-radius: 8px;
  }

  button {
    /deep/ span {
      color: rgb(234, 34, 33) !important;
    }
  }


}

/deep/ .ant-radio-wrapper {
  width: 100%;
}

.radio-group-style {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 600px;
}

.radio-chose {
  background-color: rgb(245, 245, 245);

  /deep/ span {
    color: rgb(234, 34, 33) !important;
  }

  img {
    display: block !important;
  }


}

.index_box {
  width: 100%;
  /*width: 1600px;*/
  overflow-x: auto;
}

.index_box .item_title {
  font-size: 18px;
  color: #333;
  font-weight: 600;
  line-height: 48px;
}

.index_box .item_box {
  width: 100%;
  height: 915px;
  background-color: #fff;
  overflow-y: auto;
  margin: 0 17px 20px 0;
  /*margin-right: .5%;*/

}

.index_box .item_top {
  border-bottom: 1px solid rgba(153, 153, 153, 0.1);
  padding: 14px;
}

.index_box .item_top_one {
  border-bottom: 1px solid rgba(153, 153, 153, 0.1);
  /*padding: 14px;*/
}

.index_box .item_top_one .item_top_small {
  width: 50%;
  cursor: pointer;
  padding: 14px 0 14px 14px;
  background-color: #f6f6f6;
  display: flex;
}

@media screen and (max-device-width: 1920px) {

  .type_data {
    width: 100%;
    position: absolute;
    text-align: center;
    bottom: 10px;
    font-size: 16px;
    font-weight: bold;
  }

  .index_box .no_contact_box .dotted_line_data {
    width: 60%;
    height: 268px;
    /*background-color: red;*/
    position: absolute;
    right: 10px;
    bottom: 82px;
  }

  .index_box .dotted_line_data .dotted_line_box {
    height: 72px;
    text-align: right;
    padding-top: 40px;
    font-size: 16px;
    padding-right: 14px;
  }
}

@media screen and (max-width: 1366px) {
  /* 如果视口宽度 <= 1366，将会应用这里的 CSS 代码 */
  .index_box .item_top_one .item_top_small_again {
    display: flex;
    padding: 0;
    line-height: 52px;
    justify-content: center;
    flex-wrap: nowrap
  }

  /deep/ .range_picker > span {
    padding: 2px 0;
    font-size: 12px;
  }

  .screen_time_again {
    float: right !important;
    width: 70% !important;
  }

  .screen_time_again div {
    width: 68% !important;
  }

  .type_data {
    width: 100%;
    position: absolute;
    text-align: center;
    bottom: 5px;
    font-size: 16px;
    font-weight: bold;
  }

  .index_box .no_contact_box .dotted_line_data {
    width: 60%;
    height: 266px;
    /*background-color: red;*/
    position: absolute;
    right: 10px;
    bottom: 82px;
  }

  .index_box .dotted_line_data .dotted_line_box {
    height: 71px;
    text-align: right;
    padding-top: 40px;
    font-size: 16px;
    padding-right: 14px;
  }
}

.active {
  background-color: #ffffff !important;
}

.index_box .item_img {
  width: 20px;
  height: 18px;
  margin-right: 6px;
}

.index_box .item_img img {
  width: 100%;
  height: 100%;
}

.index_box .agency_sth {
  font-size: 16px;
  color: #333;
}

.index_box .agency_num {
  font-size: 14px;
  color: #999;
}

.index_box .no_complete {
  font-size: 14px;
  color: #666;
}

.index_box .down_img {
  width: 14px;
  height: 9px;
  margin-left: 8px;

}

.index_box .down_img img {
  width: 100%;
  height: 100%;
}

.index_box .agency_box {
  padding: 16px;
}

.index_box .agency_item {
  margin-bottom: 17px;
}

.index_box .regular_follow {
  height: 16px;
  border-left: 2px solid #D90B18;
  font-size: 14px;
  line-height: 16px;
  color: #333;
  padding-left: 10px;
}

.index_box .agency_rate {
  padding: 12px 12px 0 12px;
}

.index_box .agency_rate .contacts_num {
  font-size: 14px;
  color: #666;
}

.index_box .agency_rate .today_rate {
  font-size: 12px;
  color: #666;
  line-height: 18px;
  margin-top: 4px;
}

.index_box .agency_rate .progress_bar {
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background-color: #ededed;
}

.index_box .agency_rate .progress {
  width: calc(100% / 6);
  height: 10px;
  background-color: #3DA2FB;
  border-radius: 5px;

}

.index_box .agency_title {
  margin-bottom: 8px;
}

.index_box .be_overdue {
  width: 42px;
  height: 21px;
  background-color: #E9F5FC;
  font-size: 14px;
  color: #3da2fb;
  line-height: 21px;
  text-align: center;
  margin-right: 5px;
}

.index_box .be_overdue_name {
  font-size: 14px;
  color: #333;
  line-height: 21px;
}

.index_box .be_overdue_time {
  font-size: 14px;
  color: #666;
  line-height: 21px;
}

.index_box .no_contact_box {
  /*width: 540px;*/
  /*height: 450px;*/
  height: 293px;
  background-color: #fff;
  overflow-y: auto;
  margin: 48px 0 15px 0;
}

.index_box .no_contact {
  padding: 0 17px;
}

.index_box .contact_item {
  padding: 12px 0;
  border-bottom: 1px solid rgba(153, 153, 153, 0.1);
}

.index_box .contact_head {
  width: 55px;
  height: 55px;
  margin-right: 10px;
}

.index_box .contact_head img {
  width: 100%;
  height: 100%;
}

.index_box .contact_name {
  font-size: 14px;
  color: #333;
}

.index_box .customer_com {
  overflow: hidden; /*超出宽度部分的隐藏*/
  white-space: nowrap; /*文字不换行*/
  text-overflow: ellipsis; /*超出则...代替*/
}

.index_box .contact_name span {
  color: #3da2fb;
}

.index_box .customer_details {
  margin-top: 4px;
}

.index_box .item_data {
  padding: 20px 17px;
}

.box_item {
  width: 33%;
  margin-right: .45%;
}

.index_box .box_item:last-child {
  margin-right: 0;
}

.index_box .screen_time {
  width: 100%;
  margin-bottom: 35px;
}

#components-popover-demo-placement .ant-btn {
  width: 70px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}

.index_box .tips_details img {
  width: 100%;
  height: 100%;
}

.index_box .search_tips {
  width: 5%;
  margin-left: 5px;
}

.index_box .date_screen {
  margin-left: 5px;
}

.index_box .tips_img {
  width: 14px;
  height: 13px;
}

.index_box .tips_img img {
  width: 100%;
  height: 100%;
}

.index_box .customer_type {
  margin-bottom: 20px;
}

.index_box .customer_img {
  width: 31px;
  height: 21px;
  margin-right: 12px;
}

.index_box .customer_num {
  margin-bottom: 15px;
}

.index_box .customer_item {
  width: 49%;
  margin: 0 1% 6px 0;
  border-radius: 5px;
  background-color: #f6f6f6;
  padding: 20px;
  cursor: pointer;
}

.index_box .customer_item .item_num {
  font-size: 24px;
  color: #333;
  font-weight: 600;

}

.index_box .customer_item .item_text {
  font-size: 14px;
  color: #666;
}

.search {
  .item {
    margin-bottom: 12px;

    .label {
      width: 70px;
      display: inline-block;
    }

    /deep/ .ant-select {
      width: 75%;
    }

  }

  .opt {
    text-align: center;

    button {
      margin: 0 6px;
    }
  }
}

.percent {
  position: absolute;
  top: 80px;
  right: 0;
  list-style-type: none;
  width: 200px;

  li {
    border-bottom: 1px dashed #fff;
    height: 70px;
    padding-top: 50px;
    text-align: right;
  }

  li:nth-child(1) {
    border-color: #488fea;
    color: #488fea;
  }

  li:nth-child(2) {
    border-color: #47c6eb;
    color: #47c6eb;
  }

  li:nth-child(3) {
    border-color: #5aedc2;
    color: #5aedc2;
  }

  li:nth-child(4) {
    border-color: #68eab1;
    color: #68eab1;
  }
}
/deep/.ant-cascader-input.ant-input::-webkit-input-placeholder{
  color: rgba(0, 0, 0, 0.65);
}

</style>








